import Model from './Model';

export default class ScheduledServiceTime extends Model {
  resource() {
    return 'scheduled-service-times';
  }
}
